import {
  createFrontendModule,
  ThemeBlueprint,
} from '@backstage/frontend-plugin-api';
import { UnifiedThemeProvider } from '@backstage/theme';
import { appviaTheme } from '../styles/theme';

export const appviaThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'appvia-theme',
      params: {
        theme: {
          id: 'appvia-light',
          title: 'Appvia Light',
          variant: 'light',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={appviaTheme}>
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
  ],
});
